import 'lite-youtube-embed'
import 'lite-vimeo-embed/module/lite-vimeo-embed'

import 'virtual:svg-icons-register'
import.meta.glob('../img/**/*')

import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
 

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

import { headlineTransitions } from './contentTransitions'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText);

const handleScrollDown = () => {
  const scrollTarget = window.innerHeight * 0.85
  window.scrollTo({
    top: scrollTarget,
    behavior: 'smooth'
  })
}

export function init() {
  const APP = window.APP || {
    CONFIG: {},
  }

  window.Alpine = Alpine

  Alpine.plugin(collapse)
  Alpine.plugin(focus)
  Alpine.plugin(intersect)


  window.APP = {
    ...APP,
    Alpine,
    // Alpine components
    // Other widgets / modules
    modules: {},
  }

  Alpine.data('headlineTransitions', headlineTransitions)
  Alpine.data('scrollHandler', () => ({
    scrollDown() {
      handleScrollDown()
    }
  }))
  Alpine.start()
}

window.addEventListener('DOMContentLoaded', init)

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
